export default class GroupingResidentItem {
    public id: number;
    public name: string;
    public address: string;
    public gender: string;
    public age: number|string;
    public interests: string;
    public educationTags: string;

    constructor(
        id: number,
        firstName: string,
        lastName: string,
        address: string,
        gender: string,
        age: number|null,
        interests: any,
        educationTags: any,
    ) {
        this.id = id;
        this.name = `${firstName} ${lastName}`;
        this.address = address;
        this.gender = gender !== null ? gender : '';
        this.age = age !== null ? age : '';
        this.educationTags = educationTags.join(', ');
        this.interests = interests.join(', ');
    }
}
